module.exports = __webpack_public_path__ + "static/media/sort-filter-icon.84b2c6ed.svg";